export const acceptedFilesTypes = '.txt, .pdf, .docx';